/**
 * @generated SignedSource<<785c2d82d9f38c4de1810640349645d2>>
 * @relayHash 4cc392b55aea773edf2693da62b6c34d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06414d2bbafd5a173cca709236f01be6ed95853bfc16b105fbbd9d9cf12ffc22

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery } from './mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery.graphql';

const node: PreloadableConcreteRequest<mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "06414d2bbafd5a173cca709236f01be6ed95853bfc16b105fbbd9d9cf12ffc22",
    "metadata": {},
    "name": "mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
